import { render, staticRenderFns } from "./large-image.vue?vue&type=template&id=50f97ab2&scoped=true"
import script from "./large-image.vue?vue&type=script&lang=js"
export * from "./large-image.vue?vue&type=script&lang=js"
import style0 from "./large-image.vue?vue&type=style&index=0&id=50f97ab2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f97ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f97ab2')) {
      api.createRecord('50f97ab2', component.options)
    } else {
      api.reload('50f97ab2', component.options)
    }
    module.hot.accept("./large-image.vue?vue&type=template&id=50f97ab2&scoped=true", function () {
      api.rerender('50f97ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/components/large-image.vue"
export default component.exports